import { baseApi } from './baseApi';

/**
 * Roles API endpoints
 * Handles CRUD operations for role management
 */
export const rolesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET /roles - Fetch all roles
    getRoles: builder.query({
      query: () => '/roles',
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ role_id }) => ({ type: 'Role', id: role_id })),
              { type: 'Role', id: 'LIST' },
            ]
          : [{ type: 'Role', id: 'LIST' }],
    }),

    // GET /roles/:id - Fetch role by ID
    getRoleById: builder.query({
      query: (id) => `/roles/${id}`,
      providesTags: (result, error, id) => [{ type: 'Role', id }],
    }),

    // POST /roles - Create new role
    createRole: builder.mutation({
      query: (roleData) => ({
        url: '/roles',
        method: 'POST',
        body: roleData,
      }),
      invalidatesTags: [{ type: 'Role', id: 'LIST' }],
    }),

    // PATCH /roles/:role_id - Update role
    updateRole: builder.mutation({
      query: ({ role_id, ...roleData }) => ({
        url: `/roles/${role_id}`,
        method: 'PATCH',
        body: roleData,
      }),
      invalidatesTags: (result, error, { role_id }) => [
        { type: 'Role', id: role_id },
        { type: 'Role', id: 'LIST' },
      ],
    }),

    // DELETE /roles/:id - Delete role
    deleteRole: builder.mutation({
      query: (id) => ({
        url: `/roles/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'Role', id },
        { type: 'Role', id: 'LIST' },
      ],
    }),
  }),
});

// Export hooks for use in components
export const {
  useGetRolesQuery,
  useGetRoleByIdQuery,
  useCreateRoleMutation,
  useUpdateRoleMutation,
  useDeleteRoleMutation,
} = rolesApi;

